import React from "react";
import { Crown } from "lucide-react";

/**
 * The Sovereign Founder badge — Zero-Gap Consistency: uses the EXACT same font-family
 * (Playfair Display, Georgia, serif, italic) and gold gradient stops as the Silver/Gold
 * Seals (see SealBadge.js: #f6e3a3 -> #c9a24a -> #8a6a2a) for a unified brand aesthetic.
 */
const SIZES = {
  xs: { pad: "px-1.5 py-0.5 gap-1", text: "text-[9px]", icon: "w-2.5 h-2.5" },
  sm: { pad: "px-2.5 py-1 gap-1.5", text: "text-[11px]", icon: "w-3.5 h-3.5" },
  md: { pad: "px-3.5 py-1.5 gap-2", text: "text-sm", icon: "w-4 h-4" },
  lg: { pad: "px-5 py-2.5 gap-2.5", text: "text-lg", icon: "w-5 h-5" },
};

const FounderBadge = ({ size = "sm", showLabel = true, className = "" }) => {
  const s = SIZES[size] || SIZES.sm;
  return (
    <span
      data-testid="founder-badge"
      title="Sovereign Founder"
      className={`inline-flex items-center rounded-full border shadow-sm ${s.pad} ${className}`}
      style={{
        background: "linear-gradient(135deg, #f6e3a3 0%, #c9a24a 50%, #8a6a2a 100%)",
        borderColor: "#8a6a2a",
      }}
    >
      <Crown className={`${s.icon} shrink-0`} style={{ color: "#3d2e0f" }} />
      {showLabel && (
        <span
          className={`italic font-semibold whitespace-nowrap ${s.text}`}
          style={{ fontFamily: "'Playfair Display', Georgia, serif", color: "#3d2e0f" }}
        >
          Sovereign Founder
        </span>
      )}
    </span>
  );
};

export default FounderBadge;
